export const miniProjectsAndJS30Translations = {
  en: {
    miniProjects: {
      title: "Mini Projects",
      visitSite: "Visit Site",
      projects: {
        "vue-weather-app": {
          title: "Vue Weather-App",
          description:
            "Check the weather in your city or from anywhere in the world. Type city or country!",
        },
        "typescript-tasks": {
          title: "TypeScript Tasks",
          description:
            "Create tasks and set a deadline to them. User can also delete completed tasks",
        },
        "quiz-night": {
          title: "Quiz Night",
          description:
            "Take on this Sports Quiz and test your knowledge. Chelsea quiz coming soon...",
        },
        "typescript-notes": {
          title: "TypeScript Notes",
          description:
            "User can create and delete notes! Created using React and TypeScript.",
        },
        "js-snake-game": {
          title: "JS Snake Game",
          description:
            "Speed increases as you eat food. What's your highest score?",
        },
        "javascript-calculator": {
          title: "Javascript Calculator",
          description: "A simple calculator that can do basic math operations.",
        },
        "rock-paper-scissors": {
          title: "Rock, Paper, Scissors",
          description:
            "A quick game of R-P-S, can you beat my super intelligent AI? Used Javascript, HTML and CSS",
        },
        "javascript-blackjack": {
          title: "Javascript BlackJack",
          description:
            "Can you beat my AI's logic? Don't think so... Made using JS, HTML, CSS",
        },
        "tinyme-studios": {
          title: "TinyMe Studios",
          description:
            "A landing page for a photographer client. Styling practice using JS, HTML, CSS",
        },
        "theme-toggler": {
          title: "Theme Toggler",
          description:
            "A simple theme changer. Styling practice using JS, HTML, CSS",
        },
        "js-counter": {
          title: "JS Counter",
          description:
            "A simple JS counter. Can you find both secrets? Made using JS, HTML, CSS",
        },
        "js-grocery-list": {
          title: "JS Grocery List",
          description:
            "A JS grocery List. Add/Remove/Edit your items. Made using JS, HTML, CSS",
        },
        "my-webstore": {
          title: "My Webstore",
          description:
            "A webstore using a variety of tools. Workshop ran by Ben W.",
        },
      },
    },
    javascript30: {
      title: "JavaScript 30",
      description:
        "Challenges from JS30 course (some challenges are done using only the console, so those haven't been uploaded, but you can still check them out in my repositories.) A great course to get to know the basic / fundamentals of Javascript and what goes on under the hood of it's libraries!",
      challenges: {
        js1: {
          title: "Drum Kit",
          description: "A drum kit that plays sounds with keyboard.",
        },
        js2: {
          title: "Clock",
          description: "Real-time clock. Probably needs further styling.",
        },
        js3: {
          title: "CSS Variables",
          description: "Playing with variables within CSS.",
        },
        js5: {
          title: "Flex Panels",
          description: "Where panels from this portfolio got inspiration!",
        },
        js6: {
          title: "Type Ahead",
          description: "Predictive text, highlights and searches in real-time.",
        },
        js8: {
          title: "HTML Canvas",
          description: "Draw to your heart's content.",
        },
        js10: {
          title: "CheckBoxes",
          description: "Hold shift to check boxes in between two boxes.",
        },
        js11: {
          title: "Video Player",
          description: "Coding video controls, DOM manipulation.",
        },
        js15: {
          title: "Local Storage",
          description: "Testing user local storage & event delegation.",
        },
        js16: {
          title: "Shadow Effect",
          description: "Shadow effect on mouse move.",
        },
        js17: {
          title: "Band Names",
          description: "Sorting names bypassing A/An/The.",
        },
        js18: {
          title: "Data-Time",
          description: "Converting hrs/min to secs to add up a total time.",
        },
        js20: {
          title: "Speech Detection",
          description: "Pause speaking to create a new paragraph.",
        },
        js23: {
          title: "Speech Synthesis",
          description: "Type something and choose language.",
        },
        js24: {
          title: "Sticky Nav",
          description: "Dynamic sticky nav at top of page.",
        },
        js26: {
          title: "Hover Nav Bar",
          description: "Cool transitioning Nav that follows you.",
        },
        js27: {
          title: "Click and Drag",
          description: "Dynamic click and drag to move elements.",
        },
        js28: {
          title: "Video Speed controller",
          description: "Highlight then click on how fast video plays.",
        },
        js29: {
          title: "CountDown Clock",
          description: "Feel free to use this for anything.",
        },
        js30: {
          title: "Wack-a-mole",
          description: "How many moles can you wack?",
        },
      },
    },
  },
  pt: {
    miniProjects: {
      title: "Mini Projetos",
      visitSite: "Visitar Site",
      projects: {
        "vue-weather-app": {
          title: "Vue Weather-App",
          description:
            "Verifique o clima na sua cidade ou em qualquer lugar do mundo. Digite cidade ou país!",
        },
        "typescript-tasks": {
          title: "Tarefas TypeScript",
          description:
            "Crie tarefas e defina um prazo para elas. O usuário também pode excluir tarefas concluídas",
        },
        "quiz-night": {
          title: "Quiz Night",
          description:
            "Faça este Quiz de Esportes e teste seus conhecimentos. Quiz do Chelsea em breve...",
        },
        "typescript-notes": {
          title: "Notas TypeScript",
          description:
            "O usuário pode criar e excluir notas! Criado usando React e TypeScript.",
        },
        "js-snake-game": {
          title: "Jogo da Cobra JS",
          description:
            "A velocidade aumenta conforme você come comida. Qual é sua pontuação mais alta?",
        },
        "javascript-calculator": {
          title: "Calculadora Javascript",
          description:
            "Uma calculadora simples que pode fazer operações matemáticas básicas.",
        },
        "rock-paper-scissors": {
          title: "Pedra, Papel e Tesoura",
          description:
            "Um jogo rápido de P-P-T, você consegue vencer minha IA super inteligente? Usado Javascript, HTML e CSS",
        },
        "javascript-blackjack": {
          title: "BlackJack Javascript",
          description:
            "Você consegue vencer a lógica da minha IA? Acho que não... Feito usando JS, HTML, CSS",
        },
        "tinyme-studios": {
          title: "TinyMe Studios",
          description:
            "Uma landing page para um cliente fotógrafo. Prática de estilização usando JS, HTML, CSS",
        },
        "theme-toggler": {
          title: "Alternador de Tema",
          description:
            "Um simples alternador de tema. Prática de estilização usando JS, HTML, CSS",
        },
        "js-counter": {
          title: "Contador JS",
          description:
            "Um contador JS simples. Você consegue encontrar os dois segredos? Feito usando JS, HTML, CSS",
        },
        "js-grocery-list": {
          title: "Lista de Compras JS",
          description:
            "Uma lista de compras JS. Adicione/Remova/Edite seus itens. Feito usando JS, HTML, CSS",
        },
        "my-webstore": {
          title: "Minha Loja Web",
          description:
            "Uma loja web usando uma variedade de ferramentas. Workshop conduzido por Ben W.",
        },
      },
    },
    javascript30: {
      title: "JavaScript 30",
      description:
        "Desafios do curso JS30 (alguns desafios são feitos apenas usando o console, então esses não foram enviados, mas você ainda pode verificá-los em meus repositórios.) Um ótimo curso para conhecer o básico / fundamentos do Javascript e o que acontece por baixo dos panos de suas bibliotecas!",
      challenges: {
        js1: {
          title: "Kit de Bateria",
          description: "Um kit de bateria que toca sons com o teclado.",
        },
        js2: {
          title: "Relógio",
          description:
            "Relógio em tempo real. Provavelmente precisa de mais estilização.",
        },
        js3: {
          title: "Variáveis CSS",
          description: "Brincando com variáveis dentro do CSS.",
        },
        js5: {
          title: "Painéis Flex",
          description: "De onde os painéis deste portfólio tiraram inspiração!",
        },
        js6: {
          title: "Digitação Antecipada",
          description: "Texto preditivo, destaca e pesquisa em tempo real.",
        },
        js8: {
          title: "Canvas HTML",
          description: "Desenhe à vontade.",
        },
        js10: {
          title: "Caixas de Seleção",
          description:
            "Mantenha shift pressionado para marcar caixas entre duas caixas.",
        },
        js11: {
          title: "Reprodutor de Vídeo",
          description: "Codificando controles de vídeo, manipulação de DOM.",
        },
        js15: {
          title: "Armazenamento Local",
          description:
            "Testando armazenamento local do usuário e delegação de eventos.",
        },
        js16: {
          title: "Efeito de Sombra",
          description: "Efeito de sombra no movimento do mouse.",
        },
        js17: {
          title: "Nomes de Bandas",
          description: "Ordenando nomes ignorando A/Um/O.",
        },
        js18: {
          title: "Data-Tempo",
          description: "Convertendo hrs/min em segs para somar um tempo total.",
        },
        js20: {
          title: "Detecção de Voz",
          description: "Pause a fala para criar um novo parágrafo.",
        },
        js23: {
          title: "Síntese de Voz",
          description: "Digite algo e escolha o idioma.",
        },
        js24: {
          title: "Nav Fixo",
          description: "Nav fixo dinâmico no topo da página.",
        },
        js26: {
          title: "Barra de Nav Hover",
          description: "Nav com transição legal que te segue.",
        },
        js27: {
          title: "Clicar e Arrastar",
          description: "Clicar e arrastar dinâmico para mover elementos.",
        },
        js28: {
          title: "Controlador de Velocidade de Vídeo",
          description: "Destaque e clique em quão rápido o vídeo toca.",
        },
        js29: {
          title: "Relógio de Contagem Regressiva",
          description: "Sinta-se livre para usar isso para qualquer coisa.",
        },
        js30: {
          title: "Mata-Toupeira",
          description: "Quantas toupeiras você consegue acertar?",
        },
      },
    },
  },
};

export const getMiniProjectTranslation = (language, key) => {
  const translations = miniProjectsAndJS30Translations[language];
  if (!translations || !translations.miniProjects) {
    const enTranslations = miniProjectsAndJS30Translations.en.miniProjects;
    return enTranslations?.[key] || "";
  }
  return translations.miniProjects[key] || "";
};

export const getJS30Translation = (language, key) => {
  const translations = miniProjectsAndJS30Translations[language];
  if (!translations || !translations.javascript30) {
    const enTranslations = miniProjectsAndJS30Translations.en.javascript30;
    return enTranslations?.[key] || "";
  }
  return translations.javascript30[key] || "";
};

export const getMiniProjectDetail = (language, projectKey, field) => {
  const translations = miniProjectsAndJS30Translations[language];
  if (
    !translations ||
    !translations.miniProjects ||
    !translations.miniProjects.projects
  ) {
    const enTranslations =
      miniProjectsAndJS30Translations.en.miniProjects.projects;
    return enTranslations?.[projectKey]?.[field] || "";
  }
  return translations.miniProjects.projects[projectKey]?.[field] || "";
};

export const getJS30ChallengeDetail = (language, challengeKey, field) => {
  const translations = miniProjectsAndJS30Translations[language];
  if (
    !translations ||
    !translations.javascript30 ||
    !translations.javascript30.challenges
  ) {
    const enTranslations =
      miniProjectsAndJS30Translations.en.javascript30.challenges;
    return enTranslations?.[challengeKey]?.[field] || "";
  }
  return translations.javascript30.challenges[challengeKey]?.[field] || "";
};
